import styled from '@emotion/styled';
import { Snackbar } from '@mui/material';

export const NotificationWrapper = styled(Snackbar)`
  @media (min-width: 600px) {
    right: 16px;
    top: 90px;
    bottom: inherit;
    left: inherit;
  }
`;
